import React from 'react';
import { Cable } from 'lucide-react';
import { OptionFeatures, Project } from '../../../../../types/project';
import { StatusIcon, MachineList, FeatureSection, WeldingSection } from '../common';

interface PipeInPipeSectionProps {
  project: Project;
}

export const PipeInPipeSection = ({ project }: PipeInPipeSectionProps) => {
  if (!project.projectTypes.fabrication?.options.pipeInPipe?.selected) {
    return null;
  }
  const { features } = project.projectTypes.fabrication.options.pipeInPipe;
  const getFeatureStatus = (enabled: boolean) => {
    return <StatusIcon enabled={enabled} />;
  };
  const getMachineList = (machines: any) => {
    return <MachineList machines={machines} />;
  };

  return (
    <div className="border-l-2 pl-4">
      <h5 className="text-purple-800 font-medium mb-4 flex items-center gap-2">
        <Cable className="h-5 w-5" />
        Pipe in Pipe
      </h5>
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4 relative">
        {/* Vertical Separators */}
        <div className="absolute inset-y-0 left-[19%] w-px bg-gray-200" />
        <div className="absolute inset-y-0 left-[39%] w-px bg-gray-200" />
        <div className="absolute inset-y-0 left-[59%] w-px bg-gray-200" />
        <div className="absolute inset-y-0 left-[79%] w-px bg-gray-200" />
        
        {/* Material Traceability */}
        {features.materialTraceability.enabled && (
          <FeatureSection
            title="Material Traceability"
            bgColor="bg-orange-100"
            textColor="text-orange-800"
          >
            <MachineList machines={features.materialTraceability.machines} />
          </FeatureSection>
        )}

        {/* PipeFitter */}
        {features.pipeFitter.enabled && (
          <FeatureSection
            title="PipeFitter"
            bgColor="bg-green-100"
            textColor="text-green-800"
          >
            <MachineList machines={features.pipeFitter.machines} />
          </FeatureSection>
        )}

        {/* Welding */}
        {features.welding.enabled && (
          <WeldingSection
            machines={features.welding.machines}
            bgColor="bg-purple-100"
            textColor="text-purple-800"
          />
        )}

        {/* NDT */}
        {features.ndt.enabled && (
          <FeatureSection
            title="NDT"
            bgColor="bg-yellow-100"
            textColor="text-yellow-800"
          >
            <MachineList machines={features.ndt.machines} />
          </FeatureSection>
        )}

        {/* Coating */}
        {features.coating.enabled && (
          <FeatureSection
            title="Coating"
            bgColor="bg-indigo-100"
            textColor="text-indigo-800"
          >
            <MachineList machines={features.coating.machines} />
          </FeatureSection>
        )}
      </div>
    </div>
  );
}; 